import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useDeviceType } from '@/hooks/useDeviceType';
import Navbar from '@/components/Navbar';
import Sidebar from '@/components/Sidebar';
import BottomNav from '@/components/BottomNav';
import styles from './DashboardLayout.module.css';

const DashboardLayout = () => {
  const { isMobile, isTablet, isDesktop } = useDeviceType();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className={styles.layout}>
      <Navbar onMenuClick={toggleSidebar} showMenuButton={!isDesktop} />

      <div className={styles.container}>
        {/* Sidebar: sempre visibile su desktop, overlay su tablet */}
        {isDesktop && <Sidebar />}

        {/* Sidebar overlay per tablet */}
        {isTablet && sidebarOpen && (
          <>
            <div className={styles.overlay} onClick={closeSidebar} />
            <div className={styles.sidebarOverlay}>
              <Sidebar onClose={closeSidebar} />
            </div>
          </>
        )}

        <main className={styles.main}>
          <Outlet />
        </main>
      </div>

      {/* Bottom nav solo su mobile */}
      {isMobile && <BottomNav />}
    </div>
  );
};

export default DashboardLayout;
